export default {
    formatPrice(price) {
        return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', currencyDisplay: "code"}).format(price).replace("EUR", "").trim()
        //return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price,); // This return € at the end
    },
    formatDate(dateString) {
        // TODO
        let date = new Date(dateString)

        let yyyy = date.getFullYear();
        let mm = date.getMonth() + 1; // month is zero-based
        let dd = date.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        //console.log(date)
        return(dd + '.' + mm + '.' + yyyy);
    },
    onOfficeLabelResolver(onOfficeLabels, key) {
        if(onOfficeLabels[key]) {
            return onOfficeLabels[key].label
        }

        return '';
    },
    onOfficeValueResolver(onOfficeLabels, group, key) {
        if(onOfficeLabels[group] && onOfficeLabels[group]['values'][key]) {
            return onOfficeLabels[group]['values'][key]
        }

        return '';
    },
    parseApiErrors(errors, key, index = 0) {
        if (!errors[key]) return '';

        //Always return first erorr msg (can be overriden)
        return errors[key][index];
    },
    parseRoomCount(roomCount) {
        // Rooms are as float but it makes no sense to display 1.0 rooms so if its a int we display int if its float we display float
        if(roomCount % 1 == 0) {
            return parseInt(roomCount);
        }

        return roomCount;
    }
}
